<template>
	<div class="cases-listings">
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col cols="6">
					<p class="text-muted">Settings</p>
					<h2 class="listing-title d-inline-block mb-0">User Management</h2>
				</b-col>
				<b-col cols="6" class="text-right">
				<!-- <b-col cols="6" class="text-right" v-if="auth_user.subscription.scrb_is_my_own || checkAccess(['allow_transfer_corp_credit'])"> -->
					<b-button variant="primary" class="btn-header" @click="$refs.create_user_drawer.showDrawer()">Create User</b-button>
				</b-col>
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">

			<el-tabs v-model="current_tab" @tab-click="handleTabClick">
				<el-tab-pane label="Active" name="active">
				</el-tab-pane>
				<el-tab-pane label="Inactive" name="inactive">
				</el-tab-pane>
			</el-tabs>
			<UserManagementTable :tableData="allUsers" @refresh="initComponent()"/>
		</b-container>
		<LoadingPage :is_loading="is_loading_page" />
		<CreateUserDrawer ref="create_user_drawer" @close="initComponent()"/>
	</div>
</template>
<script>
import UserManagementTable from '@/views/Configurations/UserManagement/UserManagementTable'
import CreateUserDrawer from '@/views/Configurations/UserManagement/Drawers/CreateUserDrawer'
import { Tabs, TabPane, Button } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useConfigStore } from '@/stores/configStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import LoadingPage from '@/components/LoadingPage'

export default {
	components: {
		LoadingPage,
		CreateUserDrawer,
		UserManagementTable,
		[Button.name]: Button,
		[Tabs.name]: Tabs,
		[TabPane.name]: TabPane
	},
	mixins: [
		notifyFunctionMixin,
		helperFunctionMixin
	],
	data() {
		return {
			is_loading_page: false,
			current_tab: 'active',
			search: [],
			allUsers: []
		}
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
    ...mapState(useConfigStore, ['app_code']),
		...mapState(useAccessControlStore, ['userList'])
	},
	created() {
		this.initComponent();	
	},
	mounted() {
		// caseEventBus.$on('refresh-cases', this.getHistory);
		this.is_loading_page = false;
	},
	// beforeUnmount() {
	// 	EventBus.$off('refresh-cases', this.getHistory)
	// },
	watch: {
		userList: {
			immediate: true,
			handler(newVal) {
				if(newVal) {
					this.filterUser(this.current_tab)
				}
			}
		}
	},
	methods: {
		...mapActions(useAccessControlStore,['getUplineList','getRoleList','getUsers']),
		initComponent(){
			this.is_loading_page = true;
			this.fetchAllData();
		},
		async fetchAllData() {
			try {
				await this.getUsers(_gAuth.activeCorporateId(),_gAuth.appCode());
				this.getUplineList(this.app_code,this.auth_user.account_info.corporate_id);
				this.getRoleList();
				this.is_loading_page = false;
			} catch (e) {
				this.errorFunction(e)
				this.is_loading_page = false; 
			}
		},
		filterUser(activeTab = 'active'){
			if(activeTab == 'active'){
				this.allUsers = this.userList.filter((itm)=> itm.status_text == 'ACTIVE')
			}else{	
				this.allUsers = this.userList.filter((itm)=> itm.status_text != 'ACTIVE')
			}
		},
		handleTabClick(obj, e){
			this.filterUser(obj.name)
		},
		// filterSubmit(event) {
		// 	this.search = event;
		// 	this.getHistory();
		// },
		// getSearchParams(urlSearchParams) {
		// 	if (this.isEmpty(this.search)) return urlSearchParams;
		// 	let searchParams = this.search;
		// 	for (const key in searchParams) {
		// 		if (searchParams.hasOwnProperty(key)) {
		// 			const value = searchParams[key];
		// 			if (this.isEmpty(value)) {
		// 				continue;
		// 			}

		// 			if (typeof value === 'object' && !Array.isArray(value)) {
		// 				for (const subKey in value) {
		// 					if (value.hasOwnProperty(subKey)) {
		// 						urlSearchParams.append(`search[${key}][${subKey}]`, value[subKey]);
		// 					}
		// 				}
		// 			} else {
		// 				urlSearchParams.append(`search[${key}]`, value);
		// 			}
		// 		}
		// 	}
		// 	return urlSearchParams;
		// }
	}
}
</script>